import { render, staticRenderFns } from "./moreHDP.vue?vue&type=template&id=34349202&lang=pug&"
import script from "./moreHDP.vue?vue&type=script&lang=js&"
export * from "./moreHDP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports